
// @ts-ignore
    import __i18nConfig from '@next-translate-root/i18n'
// @ts-ignore
    import __loadNamespaces from 'next-translate/loadNamespaces'
// @ts-ignore
    
import React from "react";
import useTranslation from "next-translate/useTranslation";
import Trans from "next-translate/Trans";

import { Head } from "@/components/Head";
import { useTheme } from "@/hooks/useTheme";
import { Converter } from "@/containers/Converter";

import { MagicianSection } from "@/sections/MagicianSection";
import { TrustedBySection } from "@/sections/TrustedBySection";
import { SelectFormatSection } from "@/sections/SelectFormatSection";
import { ApiTeaserSection } from "@/sections/ApiTeaserSection";
import { CTASection } from "@/sections/CTASection";
import { ShareDesignSection } from "@/sections/ShareDesignSection";
import { PricingSection } from "@/sections/PricingSection";
import { ConversionSection } from "@/sections/ConversionSection";
import { useFeatureFlags } from "@/hooks/useFeatureFlags";

const PDFToAI = () => {
  const { t } = useTranslation();
  const { colors } = useTheme();
  const { isFeatureEnabled } = useFeatureFlags();

  return (
    <>
      <Head
        pageNamespace="page/PDFToAI"
        ogImage="/images/pdf2ai-og-image.jpg"
      />

      <MagicianSection
        title={t("page/PDFToAI:title")}
        subtitle={t("page/PDFToAI:subtitle")}
        magicianLogoFile="ai"
        showStartsAt={false}
      >
        <Converter disabled={!isFeatureEnabled("DISPLAY_PDF_CONVERTERS")} />
      </MagicianSection>

      <TrustedBySection />

      <ApiTeaserSection
        title={
          ((
            <Trans
              i18nKey="page/PDFToAI:section/apiTeaser.title"
              components={[<span style={{ color: colors.ORANGE }} key={0} />]}
            />
          ) as unknown) as string
        }
        backgroundColor="#fffffe"
        cta={{
          title: t("common:actions.doNow", { do: t("common:actions.convert") }),
        }}
        elements={t("page/PDFToAI:section/apiTeaser.apiTeaserElements", null, {
          returnObjects: true,
        })}
        image={{
          src: "/images/pdf-to-ai-example.png",
          alt: "PDF to AI Example",
        }}
      />

      <ShareDesignSection
        id="ShareDesignSection"
        title={
          ((
            <Trans
              i18nKey="page/PDFToAI:section/shareDesign.title"
              components={[<span key="0" style={{ color: colors.ORANGE }} />]}
            />
          ) as unknown) as string
        }
        image={{
          src: "/images/pdf-to-ai-converted-file-elements.jpg",
          alt: t("page/PDFToAI:section/shareDesign.imageAlt"),
        }}
        backgroundColor={colors.LIGHT_GRAY1}
        cta={{
          title: t("page/PDFToAI:section/shareDesign.ctaButton"),
        }}
        elements={[
          {
            id: "ELEMENT#1",
            iconType: "SPREAD-ICON",
            title: t(
              "page/PDFToAI:section/shareDesign.elements.pathElementsTitle",
            ),
            text: t(
              "page/PDFToAI:section/shareDesign.elements.pathElementsText",
            ),
          },
          {
            id: "ELEMENT#2",
            iconType: "FOLDER-SIMPLE-ICON",
            title: t(
              "page/PDFToAI:section/shareDesign.elements.folderStructureTitle",
            ),
            text: t(
              "page/PDFToAI:section/shareDesign.elements.folderStructureText",
            ),
          },
          {
            id: "ELEMENT#3",
            iconType: "IMAGE-RED-ICON",
            title: t(
              "page/PDFToAI:section/shareDesign.elements.fullSupportTitle",
            ),
            text: t(
              "page/PDFToAI:section/shareDesign.elements.fullSupportText",
            ),
          },
        ]}
      />

      <PricingSection />
      <ConversionSection
        title={t("page/PDFToAI:section/conversion.title")}
        iconBadges={[
          {
            iconType: "SHEETS",
            text: t("page/PDFToAI:section/conversion.badges.supportsAll"),
          },
          {
            iconType: "TEXT-ICON",
            text: t("page/PDFToAI:section/conversion.badges.stickyNotes"),
          },
          {
            iconType: "GRADIENT-ICON",
            text: t("page/PDFToAI:section/conversion.badges.connectors"),
          },
        ]}
        elements={{
          from: {
            iconType: "PDF",
            image: "/images/pdf-illustrator-preview.jpg",
            title: "PDF Demo Preview",
          },
          to: {
            iconType: "AI",
            image: "/images/pdf-illustrator-preview.jpg",
            title: "Illustrator Demo Preview",
          },
        }}
      />

      <SelectFormatSection title={t("section/selectFormat:title")} />

      <CTASection title={t("section/cta:titles.pdfToAIPage")} href="#upload" />
    </>
  );
};

// Temporal workaround for https://github.com/vercel/next.js/discussions/18396
 async function _getStaticProps() {
  return {
    props: {},
  };
}

export default PDFToAI;


// @ts-ignore
    export async function getStaticProps(ctx) {
// @ts-ignore
        let res = _getStaticProps(ctx)
// @ts-ignore
        if(typeof res.then === 'function') res = await res
// @ts-ignore
        return {
// @ts-ignore
          
// @ts-ignore
          ...res,
// @ts-ignore
          props: {
// @ts-ignore
            ...(res.props || {}),
// @ts-ignore
            ...(await __loadNamespaces({
// @ts-ignore
              ...ctx,
// @ts-ignore
              pathname: '/converter/pdf-to-ai',
// @ts-ignore
              loaderName: 'getStaticProps',
// @ts-ignore
              ...__i18nConfig,
// @ts-ignore
              
// @ts-ignore
            }))
// @ts-ignore
          }
// @ts-ignore
        }
// @ts-ignore
    }
// @ts-ignore
  